import { useMemo } from 'react';
import {
  buildQueryArraySorters,
  useInfiniteTicketsFiles,
  TICKET_LIST_DEFAULT_PAGE_SIZE,
} from '@sib/api';
import { DEFAULT_PAGE } from '@sib/api/constants';

export const useTicketDocuments = (ticketId?: string) => {
  const queryPayload = useMemo(
    () => ({
      page: DEFAULT_PAGE,
      size: TICKET_LIST_DEFAULT_PAGE_SIZE,
      sort: buildQueryArraySorters([
        {
          field: 'createdAt',
          order: 'desc',
        },
      ]),
    }),
    []
  );

  const { data: filesData, isLoading } = useInfiniteTicketsFiles(
    ticketId ?? '',
    queryPayload,
    { enabled: !!ticketId }
  );

  const documents = useMemo(
    () => filesData?.pages.flatMap(page => page.items) ?? [],
    [filesData]
  );

  return {
    documents,
    isLoading,
  };
};
